/* The custom garage uses Kaching's assigned deal and Shopify's real cart.
 * Native Kaching initialization owns assignment and view attribution. */
(function (root) {
  'use strict';
  var CAR_PRODUCTS = [9763346972917, 9717217951989, 9997732151541, 9788113387765, 10266082377973];
  var OLD_CANDY_VARIANT = 50440801386741, CANDY_VARIANT = 67595837112565;
  var GHOST_PRODUCT = 10265726124277;
  var GHOST_CAR_PRODUCT = 10266082377973;
  var CANDY_CORN_PRODUCT = 10266085425397;
  function isGhost(line) { return [GHOST_PRODUCT, GHOST_CAR_PRODUCT].indexOf(Number(line.product_id)) !== -1; }
  var CONE_PRODUCT = 9707539169525;
  var CONE_VARIANT = 48237845774581;
  function isCar(line) { return CAR_PRODUCTS.indexOf(Number(line.product_id)) !== -1; }
  function isGift(line) { return !!(line.properties && ['pricing-b', 'garage-3-plus'].indexOf(line.properties._fd_gift) !== -1); }
  function tierFor(deal, count) {
    return deal && deal.dealBars.filter(function (bar) { return (!bar.dealBarType || bar.dealBarType === 'quantity-break') && bar.quantity <= Math.max(1, count); })
      .sort(function (a, b) { return b.quantity - a.quantity; })[0];
  }
  function isB() { return false; }
  function variantLetter() { return 'A'; }
  function isNew(deal) {
    var first = tierFor(deal, 1), third = tierFor(deal, 3);
    return !!(first && third && first.discountType === 'specific' && Number(first.discountValue) === 11 && third.quantity === 3 && Number(third.discountValue) === 30);
  }
  function carTotal(deal, count, base) {
    if (!count) return 0;
    var tier = tierFor(deal, count);
    if (tier && tier.discountType === 'specific') {
      if (count > 20) throw new Error('Please reduce your garage to 20 cars before checkout.');
      var conversion = Number(deal._fdCurrencyRate || 1);
      return Math.round(Number(tier.discountValue) * 100 * conversion * count / tier.quantity);
    }
    return Math.round(unitPrice(deal, count, base) * count);
  }
  function projectItems(items, deal, base) {
    var count = items.filter(isCar).reduce(function(n,l) { return n + l.quantity; }, 0);
    var total = carTotal(deal, count, base), used = 0, allocated = 0;
    return items.map(function(line) {
      if (!isCar(line)) return line;
      used += line.quantity;
      var cumulative = Math.round(total * used / count), amount = cumulative - allocated;
      allocated = cumulative;
      return Object.assign({}, line, {final_line_price:amount, final_price:amount / line.quantity});
    });
  }
  function unitPrice(deal, count, base) {
    base = Number(base || 1250);
    var tier = tierFor(deal, count);
    if (!tier) return Math.round(base * (count >= 6 ? .60 : count >= 4 ? .64 : count >= 2 ? .80 : 1));
    if (tier.discountType === 'specific') return carTotal(deal, Math.max(1, count), base) / Math.max(1, count);
    if (tier.discountType === 'default') return base;
    if (tier.discountType === 'percentage') return Math.round(base * (1 - Number(tier.discountValue) / 100));
    throw new Error('Unsupported car offer. Please refresh before checking out.');
  }
  function calculate(cars, packs, country, deal, bundles) {
    bundles = bundles || { count:0, total:0 };
    var rate = unitPrice(deal, cars, 1250), included = cars * 5;
    var giftCount = isNew(deal) && cars >= 3 ? 1 : 0;
    var subtotal = carTotal(deal, cars, 1250) + packs * 295;
    return {cars:cars, bundleCount:0, paidPacks:packs, giftPacks:giftCount, includedCones:included,
      totalCones:included + (packs + giftCount) * 20, subtotal:subtotal,
      shipping:country !== 'US' ? null : subtotal >= 2200 ? 0 : 600, perCar:rate, variant:'A'};
  }
  function ghostPairPricing(items) { return items; }
  function groupHash(value) {
    var hash = 2166136261, result = '', alphabet = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (var n = 0; n < value.length; n++) hash = Math.imul(hash ^ value.charCodeAt(n), 16777619) >>> 0;
    for (var i = 0; i < 4; i++) { result = alphabet[hash % 62] + result; hash = Math.floor(hash / 62); }
    return result;
  }
  function plan(cart, deal, country, session) {
    var cars = cart.items.filter(isCar), count = cars.reduce(function (sum, line) { return sum + line.quantity; }, 0);
    var tier = tierFor(deal, count);
    var ghostTier = null, ghostCount = 0;
    var gift = tier && count >= 3 && isNew(deal) && (tier.freeGifts || []).find(function (g) { return g.giftType === 'product'; });
    var mainProduct = cars.length ? Math.min.apply(null, cars.map(function (line) { return Number(line.product_id); })) : CAR_PRODUCTS[0];
    var selections = cars.map(function (line) { return { variantId: Number(line.variant_id), quantity: line.quantity }; }).sort(function (a, b) { return a.variantId - b.variantId; });
    var group = tier && groupHash(JSON.stringify([selections, ghostTier ? ghostCount : 0, tier.id, deal.versionId, gift && gift.id]));
    var hasProducts = tier && deal.dealBars.some(function (bar) { return (bar.freeGifts || []).some(function (g) { return g.productGID; }); });
    var common = tier ? { deal: deal.nanoId || deal.id, v: deal.versionId } : null;
    if (common && deal.abTestVariantId) { common.abid = deal.abTestVariantId; common.ab = deal.abTestVariantLetter; }
    var changes = [];
    cars.forEach(function (line) {
      var props = Object.assign({}, line.properties || {});
      delete props.__kaching_bundles; delete props.__kaching_session_id; delete props._fd_shipping_offer;
      if (tier) {
        var metadata = Object.assign({}, common, { pp: mainProduct, main: true });
        if (deal.marketId) metadata.market = deal.marketId;
        if (hasProducts || cars.some(function (c) { return c.product_id !== mainProduct; })) metadata.id = group;
        if (ghostTier) { metadata.id = group; metadata.bar = tier.id; }
        else metadata.bid = tier.id;
        props.__kaching_bundles = JSON.stringify(metadata);
        props.__kaching_session_id = session;
        if (isB(deal)) props._fd_shipping_offer = 'B';
      }
      if (JSON.stringify(props) !== JSON.stringify(line.properties || {})) changes.push({ id: line.key, quantity: line.quantity, properties: props });
    });
    var giftProps = gift ? { __kaching_bundles: JSON.stringify(Object.assign({ id: group }, common, { gift: gift.id })), _fd_gift: 'garage-3-plus' } : null;
    var gifts = cart.items.filter(isGift);
    var retained = false;
    gifts.forEach(function (line) {
      if (!gift || retained || Number(line.variant_id) !== CONE_VARIANT) changes.push({ id: line.key, quantity: 0 });
      else {
        retained = true;
        if (line.quantity !== 1 || JSON.stringify(line.properties) !== JSON.stringify(giftProps)) changes.push({ id: line.key, quantity: 1, properties: giftProps });
      }
    });
    return { changes: changes, addGift: gift && !retained ? { id: CONE_VARIANT, quantity: 1, properties: giftProps } : null,
      count: count, tier: tier, group: group };
  }
  var core = { isNew:isNew, carTotal:carTotal, projectItems:projectItems, unitPrice: unitPrice, variantLetter: variantLetter, ghostPairPricing: ghostPairPricing, isGhost: isGhost, isCar: isCar, isGift: isGift, tierFor: tierFor, isB: isB, calculate: calculate, plan: plan };
  if (typeof module !== 'undefined' && module.exports) { module.exports = core; return; }

  var config = JSON.parse(document.getElementById('fd-kaching-config').textContent);
  var bootstrap = root.FDPricing;
  root.FDGarageCatalog = {};
  (config.variants || []).forEach(function (variant) {root.FDGarageCatalog[String(variant.id)] = variant.product_id;});
  // Cached older theme documents can still load this asset during publication.
  if (!bootstrap) {
    var previewUrl = new URL(location.href);
    var previewSession = previewUrl.searchParams.get('preview_kaching_session_id');
    if (previewSession && /^[0-9a-f]{8}-[0-9a-f-]{27}$/i.test(previewSession)) {
      try { localStorage.setItem('kaching_session_id', previewSession); } catch (_) {}
      previewUrl.searchParams.delete('preview_kaching_session_id');
      history.replaceState(null, '', previewUrl.toString());
    }
  }
  var rawFetch = root.fetch.bind(root), queue = Promise.resolve(), currentCart = null;
  var deal = null, widget = null, session = '', readyResolve, loading = true, lastTier = null;
  var ready = bootstrap ? bootstrap.ready : new Promise(function (resolve) { readyResolve = resolve; });
  if (bootstrap) readyResolve = bootstrap.resolveReady;
  root.kachingBundlesDisableAddToCartHandling = true;
  document.documentElement.dataset.fdOffer = 'loading';
  function api(path, body) {
    var options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (body !== undefined) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    return rawFetch(config.root + path, options).then(async function (response) {
      var json = await response.json();
      if (!response.ok) throw new Error(json.description || json.message || 'Unable to update your cart. Please try again.');
      return json;
    });
  }
  function describe(cart) {
    var count = 0, packs = 0;
    cart.items.forEach(function (line) {
      line.isCar = isCar(line);
      line.locked = isGift(line);
      if (line.locked) line.can_increase = false;
      if (line.isCar) count += line.quantity;
      if ([CONE_PRODUCT, CANDY_CORN_PRODUCT].indexOf(Number(line.product_id)) !== -1 && !isGift(line)) packs += line.quantity;
    });
    cart.offer = calculate(count, packs, config.country, deal);
    cart.offer.subtotal = cart.total_price;
    cart.offer.shipping = config.country !== 'US' ? null : cart.total_price >= 2200 ? 0 : 600;
    currentCart = cart;
    updateShipping(cart);
    return cart;
  }
  function report(error) {
    var element = document.getElementById('fd-cart-error');
    if (!element) {
      element = document.createElement('div'); element.id = 'fd-cart-error'; element.setAttribute('role', 'alert');
      element.style.cssText = 'position:fixed;bottom:12px;left:12px;right:12px;z-index:999999;padding:14px;background:#fff;color:#9d1919;border:1px solid #d78d8d;border-radius:8px;font:14px Inter,sans-serif';
      document.body.appendChild(element);
    }
    element.textContent = error.message || 'Unable to update your cart. Please try again.';
    setTimeout(function () { element.remove(); }, 8000);
  }
  async function reconcile(cart) {
    var hadGift = cart.items.some(isGift), addedGift = false;
    // Each change returns fresh line keys; never reuse a key after properties change.
    for (var i = 0; i < 40; i++) {
      // Transfer old Candy cart lines once, even if a response was lost.
      var oldCandy = cart.items.find(function (line) {return Number(line.variant_id) === OLD_CANDY_VARIANT;});
      if (oldCandy) {
        var migrated = cart.items.filter(function (line) {return Number(line.variant_id) === CANDY_VARIANT && (line.properties || {})._fd_migrated_candy === oldCandy.key;})
          .reduce(function (n,line) {return n + line.quantity;},0);
        if (migrated < oldCandy.quantity) await api('cart/add.js', {items:[{id:CANDY_VARIANT, quantity:oldCandy.quantity - migrated,
          properties:Object.assign({}, oldCandy.properties || {}, {_fd_migrated_candy:oldCandy.key})}]});
        cart = await api('cart/change.js', {id:oldCandy.key, quantity:0});
        continue;
      }
      var next = plan(cart, deal, config.country, session);
      if (next.changes.length) { cart = await api('cart/change.js', next.changes[0]); continue; }
      if (next.addGift) { await api('cart/add.js', { items: [next.addGift] }); addedGift = true; cart = await api('cart.js'); continue; }
      var attrs = { _fd_offer: config.country === 'US' ? variantLetter(deal) : 'A', _fd_pricing_test: '', _fd_pricing_variant_id:'', _fd_rollout:'pricing-11-22-30-20260930' };
      if (session && deal) attrs._kaching_session_id = session;
      if (Object.keys(attrs).some(function (key) { return (cart.attributes || {})[key] !== attrs[key]; })) cart = await api('cart/update.js', { attributes: attrs });
      if (widget && next.tier && lastTier !== next.tier.id && next.count) {
        lastTier = next.tier.id;
        widget.setAttribute('selected-deal-bar-id', next.tier.id);
        widget.dispatchEvent(new CustomEvent('deal-bar-selected', { detail: { dealBarId: next.tier.id } }));
      }
      cart = describe(cart);
      if (isNew(deal) && addedGift && !hadGift && cart.items.some(function (line) { return isGift(line) && line.quantity === 1 && line.final_line_price === 0; })) {
        document.dispatchEvent(new CustomEvent('fd:free-cones-added', {detail:{quantity:1}}));
      }
      return cart;
    }
    throw new Error('Your cart could not finish updating. Please refresh and try again.');
  }
  function limit(cart, path, body) {
    if (!isNew(deal)) return;
    var oldCount = cart.items.filter(isCar).reduce(function (sum, line) { return sum + line.quantity; }, 0), count = oldCount;
    function catalogCar(id) { return (config.variants || []).some(function (v) { return Number(v.id) === Number(id) && v.isCar; }) || cart.items.some(function (l) { return l.variant_id === Number(id) && isCar(l); }); }
    if (/add/.test(path)) (body.items || [body]).forEach(function (line) { if (catalogCar(line.id)) count += Number(line.quantity || 1); });
    if (/change/.test(path)) {
      var line = body.line ? cart.items[Number(body.line) - 1] : cart.items.find(function (l) { return l.key === body.id || String(l.variant_id) === String(body.id); });
      if (line && isCar(line)) count += Number(body.quantity) - line.quantity;
      if (line && isGift(line)) throw new Error('Your free cone pack updates automatically with your cars.');
    }
    if (/update/.test(path) && body.updates) cart.items.forEach(function (line, index) {
      var next = Array.isArray(body.updates) ? body.updates[index] : body.updates[line.key] === undefined ? body.updates[line.variant_id] : body.updates[line.key];
      if (next !== undefined && isCar(line)) count += Number(next) - line.quantity;
    });
    if (count > 20 && count > oldCount) throw new Error('You can add up to 20 cars.');
  }
  function request(url, options) {
    var parsed = new URL(String(url), location.origin);
    var match = parsed.pathname.match(/\/cart(?:\/(add|change|update|clear))?\.js$/);
    if (parsed.origin !== location.origin || !match) return rawFetch(url, options);
    var task = queue.catch(function () {}).then(async function () {
      await ready;
      var cart = await api('cart.js');
      if (match[1]) {
        var body = options && options.body ? JSON.parse(options.body) : {};
        limit(cart, match[1], body);
        var result = await api('cart/' + match[1] + '.js', body);
        cart = match[1] === 'add' ? await api('cart.js') : result;
      }
      cart = await reconcile(cart);
      return new Response(JSON.stringify(cart), { status: 200, headers: { 'Content-Type': 'application/json' } });
    });
    queue = task;
    task.catch(report);
    return task;
  }
  function updateShipping(cart, scope) {
    var free = cart.offer.shipping === 0;
    (scope || document).querySelectorAll('[data-pricing-shipping-note]').forEach(function (el) {
      if (!scope && el.hasAttribute('data-pricing-shipping-preview')) return;
      el.textContent = free ? 'Free U.S. shipping' : 'Free U.S. shipping on orders $22+';
      el.hidden = config.country !== 'US'; el.classList.toggle('is-free', free);
    });
  }
  function verifyCheckout(cart) {
    var cars = cart.items.filter(isCar).reduce(function(n,l) { return n + l.quantity; }, 0);
    if (cars && !deal) throw new Error('Pricing is still loading. Please refresh before checkout.');
    if (isNew(deal)) {
      if (cars > 20) throw new Error('Please reduce your garage to 20 cars before checkout.');
      var gifts = cart.items.filter(isGift);
      if (cars >= 3 && (gifts.length !== 1 || gifts[0].quantity !== 1 || gifts[0].final_line_price !== 0)) throw new Error('Your free cone pack is still updating. Please try again.');
      if (cars < 3 && gifts.length) throw new Error('Your cone pack is still updating. Please try again.');
    }
  }
  async function checkout() {
    await queue.catch(function () {});
    var response = await request(config.root + 'cart.js');
    var cart = await response.json();
    if (!cart.item_count) throw new Error('Add an item to your cart first.');
    verifyCheckout(cart);
    location.assign(config.root + 'checkout');
  }
  function finishAssignment() {
    if (!loading) return;
    var candidate = document.querySelector('#fd-kaching-engine kaching-bundles-block');
    if (candidate) {
      var assigned = JSON.parse(candidate.getAttribute('deal-block') || 'null');
      if (!assigned || !Array.isArray(assigned.dealBars)) return;
      widget = candidate; deal = assigned;
      var nativeConfig = JSON.parse(candidate.getAttribute('config') || '{}');
      deal._fdCurrencyRate = Number(nativeConfig.currencyRate || 1);
      try { session = localStorage.getItem('kaching_session_id') || ''; } catch (_) {}
      if (!session && typeof widget.items === 'function') {
        var nativeItem = widget.items().find(function (line) { return line.properties && line.properties.__kaching_session_id; });
        if (nativeItem) session = nativeItem.properties.__kaching_session_id;
      }
    } else return;
    loading = false;
    document.documentElement.dataset.fdOffer = isB(deal) ? 'B' : 'A';
    document.documentElement.dataset.fdPriceVariant = variantLetter(deal);
    readyResolve();
    document.dispatchEvent(new CustomEvent('fd:offer-ready', { detail: { variant: variantLetter(deal) } }));
  }
  root.FDPricing = {
    request: request, ready: ready, isCar: isCar, ghostPairPricing: ghostPairPricing, maxCars:20, isGift:isGift, isNew:function () { return isNew(deal); },
    projectItems:function (items, base) { return projectItems(items, deal, base); },
    verify:verifyCheckout, isB: function () { return isB(deal); },
    unitPrice: function (count, base) { return unitPrice(deal, count, base); },
    variant: function () { return config.country === 'US' ? variantLetter(deal) : 'A'; },
    calculate: function (cars, packs, country, bundles) { return calculate(cars, packs, country || config.country, deal, bundles); },
    snapshot: function () { return currentCart; }, updateShipping: updateShipping,
    checkout: function () { return checkout().catch(report); }, report: report
  };
  // Existing international theme components also use this route. Their display
  // is unchanged, while returning U.S. carts lose any U.S.-only gift/metadata.
  root.fetch = function (url, options) {
    if (typeof url === 'string' && /\/cart(?:\/(?:add|change|update|clear))?\.js(?:\?|$)/.test(url)) {
      if (!options || !options.body || typeof options.body === 'string') return request(url, options);
    }
    return rawFetch(url, options);
  };
  root.addEventListener('kaching-bundles-initialized', finishAssignment);
  {
    var observer = new MutationObserver(finishAssignment);
    function observeAssignment() {
      if (!loading) return;
      var engine = document.getElementById('fd-kaching-engine');
      if (engine) observer.observe(engine, { subtree: true, childList: true, attributes: true, attributeFilter: ['deal-block'] });
      finishAssignment();
    }
    if (document.getElementById('fd-kaching-engine')) observeAssignment();
    else document.addEventListener('DOMContentLoaded', observeAssignment, { once: true });
    ready.then(function () { observer.disconnect(); });
    setTimeout(function () {
      if (!loading) return;
      // An unavailable app must not show a price that checkout cannot enforce.
      loading = false; deal = null; readyResolve(); document.documentElement.dataset.fdOffer = 'A';
      document.dispatchEvent(new CustomEvent('fd:offer-ready', { detail: { variant: 'A' } }));
    }, 10000);
  }
  document.addEventListener('fd:cart-updated', function (event) { if (event.detail && event.detail.cart && event.detail.cart.offer) updateShipping(event.detail.cart); });
  document.addEventListener('submit', function (event) {
    var form = event.target, button = event.submitter;
    if (/\/cart\/?$/.test(new URL(form.action || location.href).pathname) && button && button.name === 'checkout') {
      event.preventDefault(); event.stopImmediatePropagation(); root.FDPricing.checkout();
    }
  }, true);
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (link && /\/cart\/change(?:\?|$)/.test(link.getAttribute('href'))) {
      event.preventDefault(); event.stopImmediatePropagation();
      var changeUrl = new URL(link.href, location.origin);
      request(config.root + 'cart/change.js', { method: 'POST', body: JSON.stringify({
        id: changeUrl.searchParams.get('id'), quantity: Number(changeUrl.searchParams.get('quantity'))
      }) }).then(function () { location.reload(); }).catch(function () {});
      return;
    }
    if (link && /\/checkout(?:\?|$|\/)/.test(link.getAttribute('href'))) {
      event.preventDefault(); event.stopImmediatePropagation(); root.FDPricing.checkout();
    }
  }, true);
})(typeof window !== 'undefined' ? window : globalThis);

